class MfcRoutes {
  static install(Vue, options) {
    Vue.prototype.$routes = Routes
  }
}

export default MfcRoutes
